module.exports = {
  'title': 'BoA 3D architectural CAD software',
  'navBoaSoftware': 'BoA software',
  'navPresentation': 'Presentation',
  'navCharacteristics': 'Characteristics',
  'navCompatibility': 'Compatibility',
  'navDownloads': 'Downloads',
  'navPricing': 'Pricing',
  'navVersions': 'Versions',
  'navNumbering': 'Numbering',
  'navBoA-4_2': 'BoA 4.2',
  'nav4_2-4_3': '4.2 → 4.3',
  'navBoA-4_3': 'BoA 4.3',
  'navBoA-4_3Localized': 'BoA 4.3 localized',
  'navBoA-4_4': 'BoA 4.4',
  'navDocumentation': 'Documentation',
  'navManuals': 'Manuals',
  'navTutorials': 'Tutorials',
  'navImages': 'Images',
  'navHatching': 'Hatching',
  'navContact': 'Contact',
  'navForum': 'Forum',
  'navLinks': 'Links'
};
